import { languages } from './language'

export const externalLink = {
  HOW_TO_SETTING_FS: {
    [languages.en]:
      'https://docs.fiingate.vn/manual/user-manual/manage-report/order-and-generate-report/how-to-set-up-financial-statements',
    [languages.vi]:
      'https://docs.fiingate.vn/manual/v/2/user-manual/report/order-and-create-report/how-to-set-financial-statements',
  },
  FACT_SHEET_SERVICE_DETAILS: {
    [languages.en]: 'https://fiingate.vn/OurSolution/FiinGatePlatform?tab=68',
    [languages.vi]:
      'https://fiingate.vn/OurSolution/FiinGatePlatform?tab=68&lang=vi-vn',
  },
  BUSINESS_CREDIT_SERVICE_DETAILS: {
    [languages.en]: 'https://fiingate.vn/OurSolution/BusinessCreditReport',
    [languages.vi]:
      'https://fiingate.vn/OurSolution/BusinessCreditReport/?lang=vi-vn',
  },
  PROVINCES: {
    [languages.en]:
      'https://docs.fiingate.vn/manual/user-manual/view-company-information/filing-status',
    [languages.vi]:
      'https://docs.fiingate.vn/manual/v/2/user-manual/view-company-information/filing-status',
  },
  CUSTOMER_SUPPORT: {
    [languages.en]: 'https://fiingroup.vn/en#DangKy',
    [languages.vi]: 'https://fiingroup.vn/#DangKy',
  },
  LEARNING_CENTER: {
    [languages.en]: 'https://docs.fiingate.vn/manual/',
    [languages.vi]: 'https://docs.fiingate.vn/manual/v/2',
  },
  PRIVACY_POLICY: {
    [languages.en]: 'https://fiingate.vn/Home/Privacystatement',
    [languages.vi]: 'https://fiingate.vn/Home/Privacystatement?lang=vi-vn',
  },
  TERMS_OF_USE: {
    [languages.en]: 'https://fiingate.vn/Home/TermsAndConditions',
    [languages.vi]: 'https://fiingate.vn/Home/TermsAndConditions?lang=vi-vn',
  },
  DATA_POLICY: {
    [languages.en]: 'https://fiingate.vn/Home/DataPolicy',
    [languages.vi]: 'https://fiingate.vn/Home/DataPolicy?lang=vi-vn',
  },
  FEATURED_NEWS: {
    [languages.en]: 'https://fiingroup.vn/NewsInsights/NewsDetail/{NewsId}',
    [languages.vi]:
      'https://fiingroup.vn/NewsInsights/NewsDetail/{NewsId}?lang=vi-vn',
  },
  REQUEST_FOR_SERVICE: {
    [languages.en]: 'https://fiingate.vn/RequestForService',
    [languages.vi]: 'https://fiingate.vn/RequestForService?lang=vi-vn',
  },
  PREVIEW_DOMESTIC_SEARCH_HOW_TO_SET_FS: {
    [languages.en]:
      'https://docs.fiingate.vn/manual/user-manual/report/how-to-order-report',
    [languages.vi]:
      'https://docs.fiingate.vn/manual/v/2/user-manual/report/how-to-order-report',
  },
  CARTS_TERM_AND_CONDITION: {
    [languages.en]: 'https://fiingate.vn/Home/TermsAndConditions',
    [languages.vi]: 'https://fiingate.vn/Home/TermsAndConditions?lang=vi-vn',
  },
}
